import { useMemo } from "react";
import { CreateInvoiceController, ServiceValues } from "../types";

// AQUI CREAR LAS FUNCIONES QUE USEN UN DISPACHER PARA PASAR AL EXTERIOR EN BASE A LOS USESTATES QUE QUIERAS CREAR

export function useCreateInvoiceController(setEditedValues: React.Dispatch<React.SetStateAction<ServiceValues>>): CreateInvoiceController {
  return useMemo<CreateInvoiceController>(() => {
    return {
      setServiceValues: (updates) => {
        setEditedValues((prev) => ({ ...prev, ...updates }));
      },
      resetservicedValues: () => {
        setEditedValues({});
      },
    };
  }, [setEditedValues]);
}
